import { Country } from 'enums';
import { AdvancedPlansFeature } from 'types';

export function filterFeaturesByCountry(
  features: AdvancedPlansFeature[],
  userCountry: Country,
): AdvancedPlansFeature[] {
  return features.filter((feature) => {
    if (feature.includedInGeos?.length && feature.excludedInGeos?.length) {
      throw new Error(
        `Feature ${feature.translationKey} was defined to be both excluded and included in specific geos`,
      );
    }
    if (feature.includedInGeos?.length) {
      return feature.includedInGeos.includes(userCountry);
    }
    if (feature.excludedInGeos?.length) {
      return !feature.excludedInGeos.includes(userCountry);
    }
    return true;
  });
}
